<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.query-flex-btns-div .total-count {
  margin-right: 16px;
  font-size: 14px;
  color: #606266;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">消息推送记录</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="showMultiQuerys = !showMultiQuerys">
          高级筛选
        </button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">消息标题/用户手机号</p>
              <el-input clearable v-model="queryInfo.selectKey" size="small" placeholder="请输入消息标题或用户手机号"
                @keyup.enter.native="getListData(pagination, true)"></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">消息分类</p>
              <el-select v-model="queryInfo.messageCategory" size="small" clearable class="full-width"
                placeholder="请选择消息分类">
                <el-option v-for="item in messageCategoryList" :key="item.code" :label="item.title"
                  :value="item.code"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">推送时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.startTime" type="datetime" size="small" prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" class="flex-1"></el-date-picker>
                <span class="time-query-line">-</span>
                <el-date-picker v-model="queryInfo.endTime" type="datetime" size="small" prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" class="flex-1"></el-date-picker>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div margin-bottom-16">
          <span class="total-count">共找到 {{ pagination.total }} 条记录</span>
          <button class="common-bg-button" @click="getListData(pagination, true)">
            搜 索
          </button>
          <button class="common-bg-button" @click="resetQuery()">重 置</button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"></ZD-table>
      </div>

      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";

export default {
  data() {
    return {
      pageConfig: pageConfig,
      tableData: [],
      pagination: { ...pageConfig.pagination },
      queryInfo: {},
      showMultiQuerys: false,
      operates: {
        width: 120,
        fixed: "right",
        list: [],
      },
      // 消息分类：充电通知['01','02','05'] 活动通知['101'] 系统通知['03'] 所有分类[]
      messageCategoryList: [
        { code: "", title: "所有分类", warnTypeList: [] },
        { code: "charging", title: "充电通知", warnTypeList: ["01", "02", "05","12"] },
        { code: "activity", title: "活动通知", warnTypeList: ["101"] },
        { code: "system", title: "系统通知", warnTypeList: ["03"] },
      ],
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
    },
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;

      // 消息分类 -> warnTypeList
      const categoryItem = _.messageCategoryList.find((item) => item.code === _.queryInfo.messageCategory);
      _.queryInfo.warnTypeList = categoryItem ? categoryItem.warnTypeList : [];

      // 时间范围
      if (!_.queryInfo.startTime) delete _.queryInfo.startTime;
      if (!_.queryInfo.endTime) delete _.queryInfo.endTime;

      const apiUrl = _.$A.messagePush?.page;
      _.$H.post(_, apiUrl, _.queryInfo)
        .then((res) => {
          const data = res.data?.data || res.data;
          _.tableData = data.content || data.list || [];
          _.pagination.total = data.totalElements || data.total || 0;
          _.$U.hideLoading(_);
        })
        .catch(() => {
          _.pagination.total = _.tableData.length;
          _.$U.hideLoading(_);
        });
    },
    resetQuery() {
      this.queryInfo = {
        selectKey: undefined,
        messageCategory: undefined,
        startTime: undefined,
        endTime: undefined,
      };
      this.pagination.current = 1;
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.init();
    window.__togglePhoneDisplay = (el) => {
      const span = el.previousElementSibling;
      if (!span || !span.classList.contains("phone-display")) return;
      const phone = el.getAttribute("data-phone");
      const masked = el.getAttribute("data-masked");
      const showing = el.getAttribute("data-showing");
      if (showing === "masked") {
        span.textContent = phone;
        el.setAttribute("data-showing", "full");
        el.style.color = "#409EFF";
      } else {
        span.textContent = masked;
        el.setAttribute("data-showing", "masked");
        el.style.color = "#909399";
      }
    };
  },
  beforeDestroy() {
    delete window.__togglePhoneDisplay;
  },
};
</script>
